<template>
  <div>
    <div>
      <h4 class="fixText primaryText--text mb-2">
        {{ cardHeadline }}
      </h4>
    </div>

    <v-card
      class="py-3 mb-6 servicesCard"
      color="cardSurface"
      :outlined="$vuetify.theme.dark"
    >
      <span v-for="(item, index) in items" :key="index">
        <v-btn
          :to="item.to ? { name: item.to, query: item.query } : ''"
          color="primary"
          text
          depressed
          @click="$emit('click', item)"
        >
          <div>
            <v-badge
              class="badgeTextColor"
              :content="item.count"
              :value="item.count ? item.count : 0"
              color="yellow"
            >
              <v-icon large class="mb-2">{{ item.icon }}</v-icon>
            </v-badge>
            <p class="mb-0">{{ item.title }}</p>
          </div>
        </v-btn>
        <v-divider
          class="d-sm-none mx-4"
          v-if="(index + 1) % 3 === 0 && index + 1 !== items.length"
        ></v-divider>
      </span>
    </v-card>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { ServicesCardObject } from "@/types/interface";

export default Vue.extend({
  props: {
    cardHeadline: {
      type: String,
    },
    value: {
      type: Array as () => Array<ServicesCardObject>,
      required: true,
    },
  },
  computed: {
    items: {
      get(): Array<ServicesCardObject> {
        return this.value;
      },
    },
  },
});
</script>
<style lang="scss" scoped>
.fixText {
  position: relative;
}
</style>

<style lang="scss">
.servicesCard {
  justify-content: center;
  text-align: center;
  .v-btn {
    letter-spacing: unset !important;
    padding: 0.5rem !important;
    margin: 0.8rem 0.4rem;
    height: auto !important;
    text-transform: capitalize;
    p {
      font-size: 0.9rem;
    }
  }
}

.badgeTextColor {
  .v-badge__badge {
    color: black;
  }
}
</style>
